import React from "react";
import { Row, Col, Typography } from "antd";
import { Link } from "react-router-dom";

const HomeTitles = ({ titleName, link }) => {
  return (
    <Row>
      <Col
        style={{
          textAlign: "start",
        }}
        span={8}
      >
        <Typography.Title level={5} className="titles-start">
          {titleName}
        </Typography.Title>
      </Col>
      <Col span={8} offset={8}>
        <Typography.Title level={5} className="titles-end">
          <Link className="titles-end-link" to={link}>
            HAMISINA BAX
          </Link>
        </Typography.Title>
      </Col>
    </Row>
  );
};

export default HomeTitles;
